/* Shared menu lifecycle, including transitions between menu and drawers. */
(() => {
 const menu=document.querySelector('#dh-menu'),toggle=document.querySelector('.dh-menu-toggle');
 if(!menu||!toggle)return;
 const reduced=matchMedia('(prefers-reduced-motion:reduce)');
 let animation=null,version=0;
 function openMenu(event){
  const start=menu.open?getComputedStyle(menu).transform:'translateX(-100%)';
  version++;animation?.cancel();
  if(!menu.open)menu.showModal();
  document.documentElement.style.overflow='hidden';toggle.setAttribute('aria-expanded','true');
  menu.querySelector('.dh-menu-close').focus({preventScroll:true});
  if(!reduced.matches&&event.detail!==0)animation=menu.animate([{transform:start},{transform:'none'}],{duration:280,easing:'cubic-bezier(.32,.72,0,1)'});
 }
 async function closeMenu(instant=false,restoreFocus=true){
  if(!menu.open)return;
  const current=++version,start=getComputedStyle(menu).transform;animation?.cancel();
  if(!instant&&!reduced.matches){animation=menu.animate([{transform:start},{transform:'translateX(-100%)'}],{duration:220,easing:'ease-out',fill:'forwards'});try{await animation.finished}catch{}}
  if(current!==version)return;
  menu.close();animation?.cancel();toggle.setAttribute('aria-expanded','false');
  if(!document.querySelector('dialog[open]'))document.documentElement.style.overflow='';
  if(restoreFocus)toggle.focus({preventScroll:true});
 }
 toggle.addEventListener('click',openMenu);
 menu.querySelector('.dh-menu-close').addEventListener('click',event=>closeMenu(event.detail===0));
 menu.addEventListener('cancel',event=>{event.preventDefault();closeMenu(true)});
 menu.addEventListener('click',event=>{
  if(event.target.closest('a'))closeMenu(true,false);
  else if(event.target===menu){const r=menu.getBoundingClientRect();if(event.clientX>r.right||event.clientX<r.left)closeMenu()}
 });
})();
